﻿import React, { useState, useEffect} from 'react';
import { PageRestricted } from 'pages/errors/page-restricted';
import { UserAccess } from 'components/user-access';
import { LocationService } from 'services';
import { ShowHide } from "components/layout";
import { NotificationToaster } from "components/notifications";
import { Intent} from '@blueprintjs/core';
import { Tabs } from 'components/navigation';
import { JobListingStandard } from 'pages/job/listing/JobListingStandard';
import { JobListingContract } from 'pages/job/listing/JobListingContract';
import { useLocation } from 'react-router-dom';

export function JobListing(props) {

    const location = useLocation();
    const [currentTab, setCurrentTab] = useState(0);
    const [reloadTabNumber, setReloadTabNumber] = useState(null);

    const [locations, setLocations] = useState({ location: [], hierarchy: [] });

    const [tabs, setTabs] = useState([
        { key: "STANDARDVIEW", title: "Standard View", selected: true },
        { key: "CONTRACTSVIEW", title: "Contracts View" },
    ]);
    const [loadingData, setLoadingData] = useState(true);

    const newState = "New";
    const cancelledState = "Cancelled";
    const waitingState = "Waiting";
    const awaitingAllocationgState = "Awaiting Allocation";
    const readyState = "Ready";
    const inProgressState = "In Progress";
    const doneState = "Done";
    const deemedDoneState = "Deemed Done";
    const overrideDeemedDoneState = "Override Deemed Done";
    const doneIncompleteState = "Done (Incomplete)";
    const failedAppointmentState = "Failed Appointment";
    const visBA = "VIS";
    const tachoBA = "Tacho";
    const auditBA = "Audit";
    const unallocationJobs = "Unallocated Jobs";
    const allocationJobs = "Allocated Jobs";
    const allJobs = "All Jobs";

    useEffect(() => {
        getLocationInfo();
    }, []);

    useEffect(() => {
        // Check for tab parameter in URL
        const searchParams = new URLSearchParams(location.search);
        const tabParam = searchParams.get('tab');
        if (tabParam === 'contracts') {
            setCurrentTab(1);
            // Update tabs state to show contracts view as selected
            setTabs(prevTabs => prevTabs.map((tab, index) => ({
                ...tab,
                selected: index === 1
            })));
        }
    }, [location.search]);


    function getLocationInfo() {
        LocationService.getFormLocationSelectorCustomLocations(['Tacho', 'Vis', 'Audit']).then(function (locationData) {
            setLocations(locationData);
        }, function (error) {
            NotificationToaster.show(Intent.DANGER, `Locations failed ${error}`);
        });
        setLoadingData(false);
    }
    function onTabClick(index) {

        var clonedTabs = [
            ...tabs
        ];

        clonedTabs = clonedTabs.map(function (t, i) {
            return {
                ...t,
                selected: index === i
            }
        });

        setTabs(clonedTabs);
        setCurrentTab(index);
    }

    function reloadDone() {
        setReloadTabNumber(null);
    }

    function reloadRequired(tabNo) {
        setReloadTabNumber(tabNo);
    }
    function setUpFilters() {

        //Filer on state will only be internal
        var itemStates = [
            { "id": newState, "name": newState },
            { "id": waitingState, "name": waitingState },
            { "id": awaitingAllocationgState, "name": awaitingAllocationgState },
            { "id": readyState, "name": readyState },
            { "id": inProgressState, "name": inProgressState },
            { "id": doneState, "name": doneState },
            { "id": cancelledState, "name": cancelledState },
            { "id": deemedDoneState, "name": deemedDoneState },
            { "id": overrideDeemedDoneState, "name": overrideDeemedDoneState },
            { "id": doneIncompleteState, "name": doneIncompleteState },
            { "id": failedAppointmentState, "name": failedAppointmentState },
        ];

        //Filter on business area will only be internal
        var itemBAs = [
            { "id": visBA, "name": visBA },
            { "id": tachoBA, "name": tachoBA },
            { "id": auditBA, "name": auditBA }
        ];

        var itemJobs = [
            { "id": allocationJobs, "name": allocationJobs },
            { "id": unallocationJobs, "name": unallocationJobs },
            { "id": allJobs, "name": allJobs }
        ];

        var itemFlsStatus = [
            { "id": "Recorded", "name": "Recorded" },
            { "id": "Fixed", "name": "Fixed" },
            { "id": "Confirmed", "name": "Confirmed" },
            { "id": "Completed", "name": "Completed" },
            { "id": "OnRoute", "name": "OnRoute" },
            { "id": "CustomerNotMet", "name": "Customer Not Met" },
            { "id": "Recorded", "name": "Recorded" },
            { "id": "CallAborted", "name": "Call Aborted" },
            { "id": "Arrival", "name": "Arrival" }
        ];


        return [
            {
                "displayName": "Status", "name": "State", "items": [
                    ...itemStates
                ]
            },
            {
                "displayName": "Business Areas", "name": "BusinessArea", "items": [
                    ...itemBAs
                ]
            },
            {
                "displayName": "Job Allocation", "name": "UnallocatedJobs", "items": [
                    ...itemJobs
                ]
            },
            {
                "displayName": "Fls Status", "name": "FlsStatus", "items": [
                    ...itemFlsStatus
                ]
            }
        ];

    }

    return (
        <UserAccess perform={props.requiredAction}
            yes={() => (
                <div className="row">

                    <div className="inline-items spacer-bottom">
                        <h1>{props.title}</h1>
                    </div>

                    <ShowHide
                        evaluator={props.administrationMode}
                        show={(
                            <div className="spacer-bottom">
                                <Tabs tabs={tabs} onClick={onTabClick} />
                            </div>
                        )}
                    />


                    <div className={currentTab === 0 && !loadingData ? 'visible' : 'hidden'}>
                        <JobListingStandard locations={locations} loading={loadingData} filters={setUpFilters()}
                            reload={currentTab === 0 && reloadTabNumber !== null && reloadTabNumber === 0} reloadDone={reloadDone} reloadRequired={reloadRequired}></JobListingStandard>
                    </div>
                    <div className={currentTab === 1 ? 'visible' : 'hidden'}>
                        <JobListingContract locations={locations} loading={loadingData} filters={setUpFilters()}
                            reload={currentTab === 1 && reloadTabNumber !== null && reloadTabNumber === 1} reloadDone={reloadDone} reloadRequired={reloadRequired}></JobListingContract>
                    </div>


                </div>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}